<template>
  <v-layout wrap v-if="content">
    <v-flex xs12>
      <v-slider
        v-model="content.Size"
        :label="$t('dtouch.height')"
        min="0"
        max="1000"
        thumb-label
        @input="handleChangeIsModified"
        hide-details
      />
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Form3Space',
    props: {
      editedItem: {
        type: Object,
        required: true
      },
      onChangeIsModified: {
        type: Function,
        required: true,
      },
    },
    data: () => ({
      content: null,
    }),
    computed: {        
      ...mapState('app', ['locale']),
    },
    watch: {
      editedItem () {
        this.prepareContent()
      },
    },
    mounted () {
      this.prepareContent()
    },
    methods: {
      prepareContent () {
        this.content = this.editedItem
      },
      handleChangeIsModified () {
        this.onChangeIsModified(this.content) 
      },
    },
  }
</script>

